// Распознавание ссылок на комнату LiveDigital.
// TeleBoss (a.teleboss.ru) — тот же LiveDigital под другим брендом и доменом.
// Правило должно совпадать с backend (LiveDigitalMeetingLinkResolver::isRoomLink):
// схема http/https, хост из списка, путь начинается с /room/.

export const LIVE_DIGITAL_HOSTS = {
    'edu.livedigital.space': 'LiveDigital',
    'a.teleboss.ru': 'TeleBoss',
};

export const LIVE_DIGITAL_ROOM_PATH_PREFIX = '/room/';

export const isLiveDigitalMeetingUrl = (value) => {
    if (!value || typeof value !== 'string') return false;

    try {
        const url = new URL(value);

        return (
            (url.protocol === 'https:' || url.protocol === 'http:') &&
            Object.prototype.hasOwnProperty.call(LIVE_DIGITAL_HOSTS, url.hostname) &&
            url.pathname.startsWith(LIVE_DIGITAL_ROOM_PATH_PREFIX)
        );
    } catch {
        return false;
    }
};

// Название сервиса по домену — чтобы в подсказке было видно, что именно распознали.
export const getLiveDigitalBrand = (value) => {
    if (!isLiveDigitalMeetingUrl(value)) return '';

    try {
        return LIVE_DIGITAL_HOSTS[new URL(value).hostname] ?? '';
    } catch {
        return '';
    }
};

// Подписи того, чей id уходит в externalUserId: по ссылке педагога — педагога, по ссылке для учащихся — ученика.
export const LIVE_DIGITAL_USER_LABELS = {
    teacher: 'ID педагога',
    student: 'ID ученика',
};

// Компактный пример того, что дописывается к ссылке — для подсказки в интерфейсе.
export const getLiveDigitalParamsExample = (userLabel = LIVE_DIGITAL_USER_LABELS.teacher) =>
    `…&externalUserId={${userLabel}}&externalMeetingId={ID занятия}`;

// Пример итоговой ссылки с плейсхолдерами — только для подсказки в интерфейсе.
export const buildLiveDigitalLinkExample = (value, userLabel = LIVE_DIGITAL_USER_LABELS.teacher) => {
    if (!isLiveDigitalMeetingUrl(value)) return '';

    try {
        const url = new URL(value);
        // ASCII-плейсхолдеры не искажаются URLSearchParams, поэтому подменяем их точным replace.
        url.searchParams.set('externalUserId', 'EXTERNAL_USER_ID');
        url.searchParams.set('externalMeetingId', 'EXTERNAL_MEETING_ID');

        return url
            .toString()
            .replace('EXTERNAL_USER_ID', `{${userLabel}}`)
            .replace('EXTERNAL_MEETING_ID', '{ID занятия}');
    } catch {
        return '';
    }
};
